import { License, State, UserSuffix } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';

export const licenseRequiresCollabAgreement = (
  state: Pick<State, 'requiresCollabAgreement'> | null | undefined,
  license: Pick<License, 'role'> | null | undefined,
): boolean => !!(state?.requiresCollabAgreement && license?.role?.suffix === UserSuffix.PMHNP);

export const isLicenseExpired = (license: Pick<License, 'expiration'> | null | undefined): boolean =>
  !!license?.expiration && CalendarDateService.date(license.expiration).isBefore(CalendarDateService.date(), 'day');
